import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { utilities } from './utilities';

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  private bankName: string = '';
  private jsonUrl = 'assets/calendar.json';

  constructor(private http: HttpClient) {
    this.bankName = utilities.getBankName();
    console.log(this.bankName);
    if (this.bankName === 'CANARA') {
      this.jsonUrl = 'assets/calendar.json';
    } else if (this.bankName === 'KEGB') {
      this.jsonUrl = 'assets/kegb.json';
    } else if (this.bankName === 'KAGB') {
      this.jsonUrl = 'assets/kagb.json';
    }
  }

  getBankName(): string {
    return this.bankName;
  }

  getCalendarData(): Observable<any> {
    return this.http.get(this.jsonUrl);
  }
}

